import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Photo extends React.Component {

  static contextTypes = {
    flash: PropTypes.object,
    modal: PropTypes.object
  }

  static propTypes = {}

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    return {
      title: 't(Change Photo)',
      method: 'PATCH',
      endpoint: '/api/admin/account',
      action: '/api/admin/account/photo',
      cancelSvg: 'chevron_left',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Photo)', name: 'photo_id', endpoint: '/api/admin/account/photo', type: 'attachmentfield', allow: {
              content_types: ['image'],
              dalle: true
            }, width: 300, multiple: false }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.pop()
  }

  _handleSuccess() {
    this.context.modal.pop()
  }

}

export default Photo
